// 字体选项
export const fontOptions = [
  { label: '宋体', value: 'simsun' },
  { label: '黑体', value: 'simhei' },
  { label: 'Arial', value: 'Arial' },
  { label: 'Times New Roman', value: 'Times New Roman' }
];

// 字重选项
export const fontWeightOptions = [
  { label: '常规', value: 'normal' },
  { label: '粗体', value: 'bold' },
  { label: '细体', value: 'light' }
];

// 字号选项
export const fontSizeOptions = [
  { label: '8px', value: 8 },
  { label: '10px', value: 10 },
  { label: '12px', value: 12 },
  { label: '14px', value: 14 },
  { label: '16px', value: 16 },
  { label: '18px', value: 18 },
  { label: '20px', value: 20 }
];

// 条形码类型选项
export const barcodeTypes = [
  { label: 'CODE128', value: 'CODE128' },
  { label: 'EAN13', value: 'EAN13' },
  { label: 'CODE39', value: 'CODE39' },
  { label: 'EAN8', value: 'EAN8' }
];
